import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf, NgStyle } from '@angular/common';
import { BannerCarouselApiModel } from '@woolworthsnz/trader-api';
import { HeroItemContentComponent } from '../hero-item-content/hero-item-content.component';
import { HeroItemMainImageComponent, LoadingStrategy } from '../hero-item-main-image/hero-item-main-image.component';
import { TealiumUtagService } from '@woolworthsnz/analytics';
import { DatalayerService } from '@woolworthsnz/styleguide';
import { homePageCarouselBannerCreativeName } from '../../constants/hero-carousel.constants';

@Component({
	selector: 'wnz-hero-item',
	standalone: true,
	imports: [NgIf, NgStyle, HeroItemContentComponent, HeroItemMainImageComponent],
	templateUrl: './hero-item.component.html',
	styleUrls: ['./hero-item.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroItemComponent {
	@Input() item: BannerCarouselApiModel;
	@Input() currentIndex: number;
	@Input() totalItemsCount: number;
	@Input() tabindex: number;
	@Input() isLazyLoading? = false;

	constructor(
		private tealiumUtagService: TealiumUtagService,
		private datalayerService: DatalayerService
	) {}

	get loadingStrategy(): LoadingStrategy {
		return this.isLazyLoading ? LoadingStrategy.Lazy : LoadingStrategy.Eager;
	}

	onSelectPromotion(): void {
		const position = this.currentIndex + 1;
		this.tealiumUtagService.link({
			tealium_event: 'select_promotion',
			ecommerce: {
				creative_name: homePageCarouselBannerCreativeName,
				creative_slot: position.toString(),
				promotion_id: this.item.id?.toString() ?? '',
				promotion_name: this.item.name ?? '',
			},
		});

		this.datalayerService.trackBannerClick({
			id: this.item.id?.toString() ?? '',
			name: this.item.name ?? '',
			creative: homePageCarouselBannerCreativeName ?? '',
			position: position,
			carouselName: 'Container',
			imagePath: this.item.mainImageUrl ?? '',
			link: this.item.buttonHref ?? '',
		});
	}
}
